module.exports = "<textarea class=\"form-control\" rows=\"{{row}}\" id=\"{{elementId}}\" placeholder=\"Content\"></textarea>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tinymice-editor/tinymice-editor.component.html
// module id = ./src/app/tinymice-editor/tinymice-editor.component.html
// module chunks = main